import {Component, Input, OnInit} from '@angular/core';
import {PlayersService} from "../../../services/players.service";
import {
  TournamentTunerMethodsService,
  availableGridTypesResponse,
} from "../../../services/tournament-tuner-methods.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: 'app-tournament-tuner',
  templateUrl: './tournament-tuner.component.html',
  styleUrls: ['./tournament-tuner.component.scss']
})
export class TournamentTunerComponent implements OnInit {

  constructor(
    private tournamentTunerService: TournamentTunerMethodsService
  ) {
  }

  ngOnInit(): void {
  }

  displayConventionalGrid(): boolean {
    return this.tournamentTunerService.chosenTournamentType === 'conventional';
  }

  displayConventionalGridTypesWithGroups(): boolean {
    return this.tournamentTunerService.enableConventionalGridTypesList;
  }

  displayGroupsOptions(): boolean {
    return this.tournamentTunerService.chosenTournamentType === 'withGroups';
  }


}
